// extracted by mini-css-extract-plugin
export default {"projects":"styles_projects__ZRSYQ","projectsDark":"styles_projectsDark__d2Lmw","projectsLight":"styles_projectsLight__CC-37"};